module.exports = __webpack_public_path__ + "static/media/alldoc.db101b5c.png";